import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  moviesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    overflow: 'auto',
    width: 'calc(100% - 250px)', // Ajustează pentru lățimea sidebar-ului
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
}));
